export const RSVP_FORM_HEADER_ID = 'fa8b95f5-c94f-4dac-72be-b9230626f426';
export const RSVP_FORM_SUBMIT_BUTTON_ID = '8dc878eb-9fe0-4581-8203-5c1ecff5d348';
export const BUYER_FORM_HEADER_ID = '8ccbadb3-b052-416f-4492-8135121b8ba0';
export const BUYER_FORM_SUBMIT_BUTTON_ID = '75db23eb-410b-4b6e-4cdf-551d3c656032';
export const TICKET_HOLDER_FORM_HEADER_ID = '53830715-00d5-44ef-488c-13dbb4d8db0d';
export const TICKET_HOLDER_FORM_SUBMIT_BUTTON_ID = '81ff6897-67ba-40d4-fbf4-9250dff89e79';
//# sourceMappingURL=forms.js.map